"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Enquiry = _interopRequireDefault(require("./Enquiry"));

var _store = _interopRequireDefault(require("./store"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EnquiryProvider = function EnquiryProvider(_ref) {
  var activity = _ref.activity,
      location = _ref.location,
      callBack = _ref.callBack,
      userID = _ref.userID;
  return _react.default.createElement(_reactRedux.Provider, {
    store: _store.default
  }, _react.default.createElement(_Enquiry.default, {
    activity: activity,
    location: location,
    callBack: callBack,
    userID: userID
  }));
};

var _default = EnquiryProvider;
exports.default = _default;